import { get } from "../../root/modules/http/get.js";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { useMainStore } from "../store/mainStore.js";
import { getRunningMode } from "./get-running-mode.js";

const checkInstallerVersionLog = log(loggingContexts.checkInstallerVersion);

export const checkInstallerVersion = async () => {
  const runningMode = getRunningMode();

  if (runningMode !== "production") {
    checkInstallerVersionLog.warn(
      "Alerter running in development mode. Installer version check skipped."
    );

    return;
  }

  const mainStore = useMainStore();

  checkInstallerVersionLog.info("checking latest installer version number");

  try {
    const response = await get(
      `${import.meta.env.VITE_APPLICATION_URL}/installer.json`
    ).text();

    checkInstallerVersionLog.info("installer.json", response);

    const responseAsValidJSON = response.replace(/\\ /g, " ");

    const { link, version } = JSON.parse(responseAsValidJSON);

    mainStore.latestInstallerVersion = version.slice(1);
    mainStore.linkToLatestInstaller = link;
  } catch (error) {
    checkInstallerVersionLog.error(
      "error fetching installer.json",
      `${import.meta.env.VITE_APPLICATION_URL}/installer.json`
    );

    checkInstallerVersionLog.error(error);
  }
};
